export default function getCleanPercentage(percentage: number): number {
  const tooLow = !Number.isFinite(percentage) || percentage < 0
  const tooHigh = percentage > 100
  return tooLow ? 0 : tooHigh ? 100 : percentage
}
